import { doClientRequest } from './core/ErplyAPI';
import { GetCashInsRequest, GetCashInsResponse, DoCashInOutRequest, DoCashInOutResponse } from './core/types';
import { ErplyAttributes } from 'utils';

export const getCashIns = (params: GetCashInsRequest) =>
  doClientRequest<GetCashInsResponse>({ ...params, request: 'getCashIns' });

export const doCashInOutRequest = (params: DoCashInOutRequest) => {
  const { attributes, ...payload } = params;
  if (attributes) {
    Object.assign(
      payload,
      new ErplyAttributes(attributes).asFlatArray,
    );
  }
  return doClientRequest<DoCashInOutResponse>({
    ...payload,
    sum: Math.abs(params.sum),
    request: params.sum < 0 ? 'POSCashOUT' : 'POSCashIN',
  })
};
